<script>
    import { onMount } from "svelte"
    import { firebase, firestore } from "../../firebase/firebase.js";
    import BorderLoader from "../../components/BorderLoader.svelte"
    import GrowLoader from "../../components/GrowLoader.svelte"
    import { navigateTo } from 'svelte-router-spa';
    import EmptyText from "../../components/EmptyText.svelte"
    import { user, userProfile } from "../../store/auth.js"
    export let currentRoute;
    export let params;

    var isUserAdmin = false;
    var searchText = '';
    var users = [];
    var backUpUsers = [];
    var uLoader = false;
    var rfLoader = false;

    $: {
        if ($user && $userProfile) {
            isUserAdmin = $userProfile.role == 'admin' ? true : false;
            init();
        }
    }

    onMount(() => {
        if ($user && $userProfile) {
            isUserAdmin = $userProfile.role == 'admin' ? true : false;
            init();
        }
    })

    async function init() {
        if (isUserAdmin) {
            await fetchUsers();
        }
    }

    async function fetchUsers() {
        uLoader = true;
        users = [];
        backUpUsers = [];
        var res = await firestore.collection('users').orderBy('created_at', 'desc').get();
        if (res && res.docs && res.docs.length != 0) {
            users = res.docs;
            backUpUsers = [...users];
        } else {
            users = []
            backUpUsers = [];
        }
        uLoader = false;
    }

    async function newUser() {
        navigateTo('/admin/users/new')
    }

    async function refreshUser() {

    }

    function viewUser(user) {
        if (user && user.data()['uid']) {
            navigateTo('/admin/users/' + user.data()['uid'])
        }
    }

    function filterUsers() {
        if (searchText) {
            if (users) {
                const filtered = backUpUsers.filter(user => user.data()['name'].toLowerCase().search(searchText.toLowerCase()) >= 0)
                users = [...filtered]
            }
        } else {
            users = backUpUsers;
        }
    }
</script>

<div class="wrapper">
    {#if isUserAdmin}
<div class="my_header">
    <div>
        Users
    </div>
    <div class="d-flex" >
        <input bind:value="{searchText}" on:input={filterUsers} placeholder="Search name" type="text" class="form-control mr-1">
        {#if rfLoader == false}
            <button on:click="{refreshUser}" type="button" class="mr-1 btn btn-outline-primary btn-sm"><i
                class="fa fa-sync-alt"></i></button>
        {:else}
            <button class="mr-1 btn btn-outline-primary btn-sm" type="button" disabled>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span class="sr-only">Refreshing</span>
            </button>
        {/if}
        <button on:click="{newUser}" type="button" class="btn btn-outline-primary btn-sm">NEW</button>
    </div>
</div>
    <div class="row no-gutters w-100 justify-content-center align-items-center flex-column">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pb-5">
            <div class="row no-gutters">
                <div class="table-responsive">
                    <table class="table table-bordered">
                        <thead class="thead-light">
                        <tr>
                            <th scope="col">Name</th>
                            <th scope="col">Email</th>
                            <th scope="col">Role</th>
                            <th scope="col">Status</th>
                            <th scope="col">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                            {#if !uLoader}
                                {#if users && users.length != 0}
                                    {#each users as user}
                                        <tr>
                                            <td >{user.data()['name']} </td>
                                            <td >{user.data()['email']}</td>
                                            <td>
                                                <span class:badge="{true}" class:badge-success="{user.data()['role'] == 'admin'}" class:badge-secondary="{user.data()['role'] == 'manager'}">{user.data()['role']}</span>
                                            </td>
                                            <td>
                                                <span class:badge="{true}" class:badge-info="{!user.data()['isDisabled']}" class:badge-dark="{user.data()['isDisabled']}">{user.data()['isDisabled'] ? 'Inactive' : 'Active' }</span>
                                            </td>
                                            <td>
                                                <div class="d-flex justify-content-center">
                                                    <button on:click="{viewUser(user)}" type="button" class="btn btn-outline-primary btn-sm"><span class="fa fa-eye "></span></button>
                                                </div>
                                            </td>
                                        </tr>
                                    {/each}
                                {:else}
                                    <tr>
                                        <td colspan="6"><EmptyText msg="No users" /></td>
                                    </tr>
                                {/if}
                            {:else}
                                <tr>
                                    <td colspan="6"><GrowLoader /></td>
                                </tr>
                            {/if}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>        
    </div>
{/if}
</div>
<style>
    .wrapper{
        border-right: 1px solid #f4f4f4;
        height: 100%;
    }

    .users-list{
        width: 100% !important;
    }

    table,
    thead,
    tr,
    tbody,
    th,
    td {
    text-align: center;
    vertical-align: middle;
    }

    .table td {
    text-align: center;
    }

    .fixed-td{
        max-width: 270px !important;
        white-space: nowrap !important;
        text-overflow: ellipsis !important;
        overflow: hidden !important;
    }
    .profile{
        width: 30px !important;
        height: 30px !important;
    }

    .my_header {
        background-color: #efefef;
        display: block;
        width: 100%;
        min-height: 68px;
        border-bottom: 1px solid #e7e7e7;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
    }
</style>